import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";

const DEFAULT_AVATAR = "https://s3.amazonaws.com/assets.evertrue.com/global/et_avatar_user_2.png";

export default class extends React.Component {
  static displayName = "Avatar";

  static propTypes = {
    url: PropTypes.string,
    name: PropTypes.string,
    width: PropTypes.number,
    emptyState: PropTypes.string,
    emptyStateStyle: PropTypes.object,
    onClick: PropTypes.func,
  };

  static defaultProps = { width: 60 };

  state = {
    url: this.props.url || DEFAULT_AVATAR,
    has_error: false,
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.url !== this.props.url) {
      this.setState({
        url: this.props.url || DEFAULT_AVATAR,
        has_error: false,
      });
    }
  }

  handleError = () => {
    // don't keep requesting if S3 is down
    if (!this.state.has_error) {
      return this.setState({
        url: DEFAULT_AVATAR,
        has_error: true,
      });
    }
  };

  render() {
    if (this.props.emptyState && (!this.props.url || this.state.has_error)) {
      return (
        <span
          className={classNames("et--avatar", "is-empty", this.props.className)}
          style={{
            width: this.props.width,
            height: this.props.width,
            lineHeight: this.props.width + "px",
            borderRadius: this.props.width,
            ...this.props.emptyStateStyle,
          }}
        >
          {this.props.emptyState}
        </span>
      );
    } else {
      return (
        <img
          data-testid="avatar"
          className={classNames("et--avatar", this.props.className)}
          style={this.props.style}
          src={this.state.url}
          alt={this.props.name}
          width={this.props.width}
          onClick={this.props.onClick}
          onError={this.handleError}
        />
      );
    }
  }
}
